module.exports = __webpack_public_path__ + "img/main_zjs.6c2d6dce.jpg";